import React, { useState } from 'react';
import { ZoButton } from '@zonofi/zo-components/input/zo-button/zo-button';
import Button from '@mui/material/Button';
import { SVGS } from '../assets';
import './your-industry.scss';
import TextField from '@mui/material/TextField';
import { SignUpContainer } from '../sign-up-container/sign-up-container';
import { SellerDetails } from '@zonofi/zo-types';
import { ErrorToast } from '../components';
import { JTBDEventType, useEventTracking } from '@zonofi/seller-rtk-store';

interface YourIndustryProps {
  goBack: () => void;
  setPlanBusiness: () => void;
  onRegister: () => void;
  sellerDetails: SellerDetails;
  onUpdateValue: (key: string, value: string) => void;
  isRegistering: boolean;
  errorObj: {
    isError: boolean;
    errorMsg: string;
  };
  closeErrorToast: () => void;
}

const industry = [
  {
    id: 'AGRICULTURE' as const,
    title: 'Agri & Rural',
    description: 'Crops, Seeds, Farm Tools.',
  },
  {
    id: 'FMCG' as const,
    title: 'FMCG & CPG',
    description: 'Food, Grocery and Dairy',
  },
  {
    id: 'CONSTRUCTION' as const,
    title: 'Construction & Hardware',
    description: 'Steel, Cement, Plywood, Hardware Materials',
  },
  // {
  //   id: 'PIPES' as const,
  //   title: 'Pipes',
  //   description: 'Steel, PVC, Coper, CPVC',
  // },
  // {
  //   id: 'OIL' as const,
  //   title: 'Oil',
  //   description: 'Packaged Cooking Oil',
  // },
  {
    id: 'ELECTRONICS' as const,
    title: 'Electrical & Appliances',
    description: '	Consumer Electricals, Durables, Fittings',
  },
  // {
  //   id: 'SCENTS_AND_FRAGRANCES' as const,
  //   title: 'ScentsCommodities, Niche Trading and Others & Fragrances',
  //   description: 'Perfumes',
  // },
  {
    id: 'FASHION_AND_RETAIL' as const,
    title: 'Apparel & Lifestyle',
    description: 'Fashion, Footwear, Jewellery',
  },
  {
    id: 'MANUFACTURING' as const,
    title: 'Auto & Industrial',
    description: 'Auto Spares, Bearings, Lubricants',
  },
  {
    id: 'HEALTHCARE' as const,
    title: 'Pharma & Wellness',
    description: 'Medical Products, Ayurvedic, Health Equipment',
  },
  {
    id: 'OTHERS' as const,
    title: 'Commodities, Niche Trading and Others',
    description: 'Stationery, Bakery, Religious, Miscellaneous Products',
  },
];

export const YourIndustry: React.FC<YourIndustryProps> = ({
  goBack,
  setPlanBusiness,
  onRegister,
  onUpdateValue,
  sellerDetails,
  isRegistering,
  errorObj,
  closeErrorToast,
}) => {
  // const [registred, setRegistred] = useState(false);

  // if (registred) {
  //     return <RegistredScreen goBack={() => setRegistred(false)} />;
  // }
  const [showWarning, setShowWarning] = useState<boolean>(false);
  const { trackEvent } = useEventTracking();

  return (
    <>
      <SignUpContainer customClass="custom">
        <div className="industryDetails">
          <h2 className="primary-font-semibold seller-font-size-heading">
            What is your industry?
          </h2>
          <p className="primary-font-regular">
            Select the industry that best represents your business operations.
          </p>
          {showWarning && (
            <span className="primary-font-regular" style={{ color: 'red' }}>
              Please select an industry
            </span>
          )}

          <div className="yourIndustry">
            <div className="industry_sec">
              {industry.map((ind) => (
                <div
                  key={ind.id}
                  className={`ind_list ${
                    sellerDetails?.industry === ind.id ? 'active' : ''
                  }`}
                  onClick={() => onUpdateValue('industry', ind.id)}
                >
                  <div
                    style={{
                      display: 'flex',
                      flexDirection: 'column',
                      gap: '4px',
                      flex: 1,
                    }}
                  >
                    <div className="industry_sec-title primary-font-semibold">
                      {ind.title}
                    </div>
                    <span
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        fontSize: '14px',
                        lineHeight: '16px',
                        color: '#8c8c8c',
                      }}
                    >
                      {ind.description}
                    </span>
                  </div>
                  {sellerDetails?.industry === ind.id ? (
                    <img src={SVGS.RadioCheckedIcon} width={24} height={24} />
                  ) : (
                    <img src={SVGS.RadioUncheckIcon} width={24} height={24} />
                  )}
                </div>
              ))}
              {sellerDetails?.industry === 'OTHERS' && (
                <div className="specifyInd">
                  <TextField
                    fullWidth
                    variant="outlined"
                    placeholder="Specify your industry"
                    size="small"
                  />
                </div>
              )}
            </div>
          </div>

          <div className="details_bottomSec">
            <Button className="backbutton" variant="text" onClick={goBack}>
              <span>
                <img
                  src={SVGS.ArrowLeftBlue}
                  width={20}
                  height={20}
                  className="ArrowLeft"
                  alt=""
                />
              </span>{' '}
              Back
            </Button>
            <ZoButton
              label="Register"
              endIcon={
                <span style={{ display: 'flex', alignItems: 'center' }}>
                  <img
                    src={SVGS.ArrowRight}
                    width={20}
                    height={20}
                    className="ArrowRight"
                  />
                </span>
              }
              onClick={() => {
                if (sellerDetails?.industry) {
                  onRegister();
                  setShowWarning(false);
                  trackEvent(JTBDEventType.SIGNUP_INDUSTRY_SELECTED, {
                    ...sellerDetails,
                  });
                } else {
                  setShowWarning(true);
                }
              }}
              className="sign-up-now-btn"
              isLoading={isRegistering}
            />
          </div>
        </div>
      </SignUpContainer>
      <ErrorToast
        isError={errorObj.isError}
        errorMsg={errorObj.errorMsg}
        onClose={closeErrorToast}
      />
    </>
  );
};
